/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 09/04/2018.
*
* users-create-view Vue Component
*/
<template>
  <div class="users-create-view">
    <top-bar
      title="Crear Usuario"
    />
    <scrollable-container>
      <users-form
        ref="form"
      />
    </scrollable-container>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import FormModal from '@/components/_shared/form-modal'
import UsersForm from '@/modules/users/users-form'
import UsersGuards from '@/guards/users.guards'

export default {
  name: 'UsersCreateView',
  components: { FormModal, UsersForm, TopBar, ScrollableContainer },
  computed: {
    dealers () {
      return this.$store.getters['dealers/items']
    },
    divisions () {
      return this.$store.getters['divisions/items']
    },
    roles () {
      return this.$store.getters['roles/items']
    }
  },
  methods: {
    onCloseModal () {
      this.$router.push({ name: 'users' })
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  },
  provide () {
    return {
      dealers: this.dealers,
      divisions: this.divisions,
      roles: this.roles,
      oldPermissions: []
    }
  },
  beforeRouteEnter: UsersGuards.onCreate
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.content {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/app/users/users-create-view.vue